import React from 'react';
export function SocialProof() {
  const testimonials = [{
    avatar: 'https://cdn.magicpatterns.com/uploads/q8swMd42c1WNLSzZGYauDU/Captura_de_pantalla_2026-04-16_a_la(s)_9.26.10_p._m..png',
    color: 'av-red',
    stars: 5,
    quote: '"Pasé de gastar una fortuna en barritas de marca a tener la heladera llena por monedas. La textura es increíble."',
    author: 'Facundo M. — Buenos Aires',
    result: 'Ahorro: $12.000/semana'
  }, {
    avatar: 'https://cdn.magicpatterns.com/uploads/mYhH6SVNtM9Rs8HGC7NEJL/Captura_de_pantalla_2026-04-16_a_la(s)_9.25.48_p._m..png',
    color: 'av-green',
    stars: 5,
    quote: '"Les mando las barritas del bono a mis hijos al colegio y les encantan. Son sanas de verdad, sin químicos raros."',
    author: 'Carina G. — Córdoba',
    result: 'Snacks sanos para toda la familia'
  }, {
    avatar: 'https://cdn.magicpatterns.com/uploads/af2mu4rcPSpBjgvLtAqj5m/Captura_de_pantalla_2026-04-16_a_la(s)_9.26.03_p._m..png',
    color: 'av-blue',
    stars: 5,
    quote: '"Reemplacé el Whey caro por la albúmina que recomiendan y el sabor es el mismo. Un viaje de ida, no vuelvo al quiosco."',
    author: 'Santi R. — Rosario',
    result: '20g proteína por menos de $800'
  }];
  const avatarColors = {
    'av-red': 'bg-gradient-to-br from-[#C2410C] to-[#F97316]',
    'av-green': 'bg-gradient-to-br from-[#15803D] to-[#22C55E]',
    'av-blue': 'bg-gradient-to-br from-[#1d4ed8] to-[#2563EB]'
  };
  return <section className="bg-[#0F172A] py-20 px-5" data-id="element-153">
      <div className="max-w-[780px] mx-auto" data-id="element-154">
        <div className="w-12 h-1 bg-gradient-to-r from-[#15803D] to-[#22C55E] rounded-sm mx-auto mb-5" data-id="element-155" />

        <h2 className="font-montserrat text-[clamp(22px,3.5vw,32px)] font-extrabold text-center mb-[10px] text-white tracking-tight leading-[1.2]" data-id="element-156">
          Lo que dicen los que ya lo probaron
        </h2>

        <p className="text-center text-[#94A3B8] text-[15px] mb-10" data-id="element-157">
          Resultados reales de personas reales
        </p>

        <div className="grid grid-cols-[repeat(auto-fit,minmax(220px,1fr))] gap-[18px] max-w-[740px] mx-auto" data-id="element-158">
          {testimonials.map((testi, idx) => <div key={idx} className="bg-[#1E293B] border border-[rgba(255,255,255,0.07)] rounded-[14px] p-[26px_22px] transition-all duration-[0.25s] hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(0,0,0,0.4)] hover:border-[rgba(34,197,94,0.25)]" data-id="element-159">
              <img src={testi.avatar} alt={testi.author} className="w-[46px] h-[46px] rounded-full object-cover mb-[14px]" data-id="element-160" />
              <div className="text-[#FACC15] text-sm mb-[10px] tracking-[2px]" data-id="element-161">
                {'★'.repeat(testi.stars)}
              </div>
              <blockquote className="text-sm leading-[1.65] text-[#94A3B8] italic mb-[14px]" data-id="element-162">
                {testi.quote}
              </blockquote>
              <p className="font-montserrat text-xs font-bold text-white tracking-[0.3px]" data-id="element-163">
                {testi.author}
              </p>
              <p className="text-[11px] text-[#22C55E] font-semibold mt-[3px]" data-id="element-164">
                {testi.result}
              </p>
            </div>)}
        </div>

        <div className="mt-12 max-w-[640px] mx-auto" data-id="element-165">
          <img src="https://cdn.magicpatterns.com/uploads/p8XcLt8ghTax9TrUQjTcLB/ChatGPT_Image_16_abr_2026,_18_43_55.png" alt="El Método Barrita Pro — Libro, tablet y app" className="w-full rounded-[20px] shadow-[0_24px_60px_rgba(0,0,0,0.45),0_0_0_1px_rgba(34,197,94,0.15)]" data-id="element-166" />
        </div>
      </div>
    </section>;
}